import { useEffect, useState } from "react"
import bscstakeAbi from '../json/bscstake.json';
import tokenAbi from '../json/token.json';
import { toast } from "react-toastify";
import { DEFAULT_CHAIN, contract } from "../helper/constant";
import { getMultiCall } from "../helper/contractHelper";
import { getWeb3 } from "../helper/connectors";




export const useCommonStats = (updater) => {

    let web3 = getWeb3();


    const [stats, setStats] = useState({
        FutureCoin: '',
        paused: true,
        totalDistributed: 0,
        totalStaked: 0,
        totalUnstaked: 0,
        tokenName: '',
        tokenSymbol: '',
        tokenDecimals: 0,
        totalStakers: 0,
        stakeAmounts : [],
        getTokenPrice : 0
    });

    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.FutureCoin(), //0
                    stakeContract.methods.StakersCount(), //1
                    stakeContract.methods.paused(), //2
                    stakeContract.methods.totalDistributed(), //3
                    stakeContract.methods.totalStaked(), //4
                    stakeContract.methods.totalUnstaked(), //5
                    stakeContract.methods.getAmounts(), //6
                    stakeContract.methods.getTokenPrice() //7
                ]);

                let tokenContract = new web3.eth.Contract(tokenAbi, data[0]);
                
                const tokenData = await getMultiCall([
                    tokenContract.methods.name(),
                    tokenContract.methods.symbol(),
                    tokenContract.methods.decimals()
                ]);

                
                setStats({
                    FutureCoin: data[0],
                    totalStakers: data[1],
                    paused: data[2],
                    totalDistributed: data[3] / Math.pow(10, tokenData[2]),
                    totalStaked: data[4] / Math.pow(10, tokenData[2]),
                    totalUnstaked: data[5] / Math.pow(10, tokenData[2]),
                    tokenName: tokenData[0],
                    tokenSymbol: tokenData[1],
                    tokenDecimals: tokenData[2],
                    stakeAmounts : data[6],
                    getTokenPrice : data[7] / Math.pow(10,18)
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }


        fetch();

        // eslint-disable-next-line
    }, [updater]);

    return stats;
}
